<!--
    描述： 项目基本信息tab页面
    时间： 2020/05/21
    created by yefan
-->
<template>
	<!-- 右侧 -->
	<div class="base-info-main">
		<!-- 右侧主体 -->
		<div class="base-info-content"
			 ref="container"
			 @scroll="handleScroll">
			<!-- 基本信息 -->
			<projectBasicInfo ref="baseInfo"
							  :showToolsBtn="showToolsBtn"
							  @onSuccess="echoProject"></projectBasicInfo>
			<!--概算信息等，动态获取区块、动态表单字段等-->
		</div>

		<!-- 右侧悬浮导航 -->
		<div class="base-info-nav">
			<el-button size="small"
					   type="primary"
					   v-if="roleBtns.includes('baseInfo-lock') || curSource === '1'"
					   @click="handleTool('isLock')">
				{{ isDisabled ? '解锁' : '锁定' }}
			</el-button>
			<el-button size="small"
					   class="mt10 ml0"
					   type="primary"
					   :loading="btnLoading"
					   v-if="roleBtns.includes('baseInfo-save') || curSource === '1'"
					   @click="handleTool('save')">保存
			</el-button>
			<el-button size="small"
					   class="mt10 ml0"
					   type="primary"
                        v-if="roleBtns.includes('baseInfo-export') || curSource === '1'"
					   :loading="btnLoading"
					   @click="handleTool('export')">导出
			</el-button>
			<!-- <li class="base-info-nav-li"
                :class="{'active-li':activeNav === index}"
                v-for="(item, index) in floorList"
                :key="index"
                @click="doScroll(item, index)">{{ item.sname }}
            </li>
            <li class="base-info-nav-button"
                @click="doExport">
                导出
            </li> -->
		</div>

		<!-- 导出弹窗 -->
		<el-dialog :visible.sync="dialogObj.visible"
				   :title="dialogObj.title"
				   :width="dialogObj.width"
				   :close-on-click-modal="false">
			<div class="block-item">导出格式：
				<el-radio v-model="exportType"
						  label="excel">excel
				</el-radio>
				<el-radio v-model="exportType"
						  label="html">html
				</el-radio>
			</div>
			<div class="block-item mt10">导出模块：
				<el-checkbox :indeterminate="isIndeterminate"
							 v-model="checkAll"
							 @change="handleCheckAllChange">全选
				</el-checkbox>
				( 注意： 基本信息模块默认导出 )
				<el-checkbox-group v-model="checkedBlock"
								   @change="handleCheck"
								   style="padding-left: 74px">
					<el-checkbox v-for="(item, index) in blockList"
								 :label="item.id"
								 :key="item.id"
								 :disabled="item.disabled">{{ item.sname }}
					</el-checkbox>
				</el-checkbox-group>
			</div>
			<!-- footer 组件 -->
			<div slot="footer"
				 class="dialog-footer text-center"
				 v-if="dialogObj.mode !== 'view'">
				<el-button size="small"
						   @click="dialogObj.visible = false">取 消
				</el-button>
				<el-button type="primary"
						   size="small"
						   :loading="dialogObj.btnLoading"
						   @click="doExport">确 定
				</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import { mapState } from 'vuex'

const projectBasicInfo = () => import('./components/project_basic_info')
import { getAllAreaTree } from '@/api/modules/dict.js'
import { exportExcel, dateFormat } from '@/utils/tools'

export default {
	name: 'project-base',
	components: {
		projectBasicInfo
	},
	data() {
		return {
			areaList: [],
			floorList: [
				{
					sname: '基本信息',
					key: 'baseInfo'
				}
			],
			// 根据项目来源判断是否可编辑
			showToolsBtn: true,
			// 悬浮导航高亮项
			activeNav: 0,
			// 控制是否锁定
			isDisabled: true,
			btnLoading: false,
			dialogObj: {
				visible: false,
				width: '700px',
				title: '导出项确认',
				btnLoading: false
			},
			exportType: 'excel', // 导出格式
			isIndeterminate: false,
			checkAll: false,
			blockList: [], // 所有区块数组
			checkedBlock: [] // 所选的导出区块
		}
	},
	methods: {
		// 点击导航滚动
		doScroll(item, index) {
			// 点击时当前的 对象
			let _current = this.floorList[this.activeNav].key
			// 当前的高度
			let currentY = this.$refs[_current].$el.offsetTop
			// 目标高度
			let targetY = this.$refs[item.key].$el.offsetTop
			// 可滚动的最大距离 = 总高度 - 可视区域高度
			let _scrollFullTop = this.$refs.container.scrollHeight
			let _clientHeight = this.$refs.container.clientHeight
		},

		// 监听页面滚动
		handleScroll() {
			let _scrollFullTop = this.$refs.container.scrollHeight
			let _clientHeight = this.$refs.container.clientHeight
			let _scrollTop = this.$refs.container.scrollTop
			let that = this
			this.floorList.some((x, index) => {
				if (
					_scrollTop >= that.$refs[x.key].$el.offsetTop &&
					_scrollTop < _scrollFullTop - _clientHeight
				) {
					// 高亮当前nav
					that.activeNav = index
				}
			})
		},

		//回显项目信息和其他六算信息
		echoProject() {},

		//获取地区字典值
		getAreaList() {
			getAllAreaTree({})
				.then(res => {
					this.areaList = res.data
				})
				.catch(err => {})
		},

		// 控制锁定 解锁
		handleTool(type) {
			switch (type) {
				case 'isLock':
					this.isDisabled = !this.isDisabled
					this.$refs.baseInfo.isDisabled = this.isDisabled
					break
				case 'save':
					this.$refs.baseInfo.saveData()
					break
				case 'export':
					this.blockList = []

					let _list = this.$refs.baseInfo.templateList || []
					this.blockList.push(..._list)

					this.dialogObj.visible = true
					break
			}
		},

		// 导出弹窗 --- 切换全选按钮
		handleCheckAllChange(val) {
			let _list = this.blockList.map(x => x.id)
			this.checkedBlock = val ? _list : []
			this.isIndeterminate = false
		},

		// 导出弹窗 --- 切换每一个区块
		handleCheck(arr) {
			let checkedCount = arr.length
			this.checkAll = checkedCount === this.blockList.length
			this.isIndeterminate =
				checkedCount > 0 && checkedCount < this.blockList.length
		},

		// 点击确认导出
		doExport() {
			this.dialogObj.btnLoading = true
			let saveName = '项目基本信息' + dateFormat('yyyy-MM-dd hh:ss:mm')
			let params = {
				ids: this.checkedBlock,
				id: this.curProjectId,
				exportType: this.exportType,
				saveName: saveName
			}
			exportExcel(
				'analysisFormTemplate/exportSixcalculations',
				params,
				saveName
			)
			setTimeout(() => {
				this.dialogObj.visible = false
				this.dialogObj.btnLoading = false
			}, 1000)
		}
	},

	computed: {
		// 当前的 项目来源：'0' 是造价系统的， '1' 是审计系统推送的
		curSource() {
			return this.$route.query.source || '0'
		},
		...mapState('dict', {
			resourcesList: state => state.gcly, // 工程来源数组
			typeList: state => state.gclx, // 工程类型数组
			biddingList: state => state.gclx // 招标方式数组
		}),
		...mapState('menu', {
			roleBtns: state => state.roleBtns
		}),

		// 当前项目ID
		curProjectId() {
			return this.$route.query.projectId
		},
	},

	created() {
		// 初始回显项目信息
		// this.echoProject()
		// this.getAreaList()
	}
}
</script>

<style lang="less" scoped>
@import url('basicInfo.less');
</style>
